import type { ImageInfo, ImageMinimumInfo } from '@app-types/commons/images.types.ts';
import { getImageUrl } from '@tools/utils/imageUtils.tsx';

export const resolveFooterImage = (
  image?: ImageInfo | ImageMinimumInfo | null,
): { srcDefault: string; srcSet?: string } | null =>
  image ? getImageUrl(image) : null;
